const CAP24 = {
  id: 24,
  slug: "cap24-historia-tecnologia-blockchain-ii",
  title: "Historia de la tecnología Blockchain (II)",
  sections: [
    {
      heading: "El nacimiento de Bitcoin: el comienzo de una nueva era",
      text: [
        "El momento más importante en la historia de la tecnología blockchain llegó en 2008, cuando una persona o grupo bajo el seudónimo de **Satoshi Nakamoto** publicó el white paper titulado **“Bitcoin: A Peer-to-Peer Electronic Cash System”**.",
        "Este documento propuso un sistema de dinero electrónico que funcionaba **sin intermediarios**, basado en una red descentralizada de nodos que validan y registran transacciones.",
        "Satoshi combinó la **criptografía de clave pública**, los **hashes**, los **árboles de Merkle** y el sistema de **timestamping** de Haber y Stornetta, dando vida a un mecanismo seguro, transparente y resistente a manipulaciones.",
        "El **3 de enero de 2009**, Satoshi Nakamoto minó el **primer bloque de Bitcoin**, conocido como el **Bloque Génesis (Genesis Block)**.",
        "Ese momento marcó oficialmente el inicio de Bitcoin y, con ello, el nacimiento de la tecnología blockchain moderna.",
        "Bitcoin se convirtió en la **primera aplicación funcional y exitosa de blockchain**, demostrando su viabilidad y enorme potencial para transformar la economía digital."
      ]
    },
    {
      heading: "La evolución de la tecnología Blockchain: de las criptomonedas a la Web3",
      text: [
        "Aunque Bitcoin fue una de las mayores innovaciones tecnológicas, su creación fue solo el comienzo.",
        "Con el paso del tiempo, blockchain evolucionó más allá de las criptomonedas, convirtiéndose en una infraestructura poderosa para aplicaciones, contratos inteligentes, identidad digital, cadenas de suministro y más.",
        "Esta evolución suele explicarse en **generaciones de blockchain**:"
      ],
      list: [
        "🔹 **Blockchain 1.0** → Transferencia de valor (Bitcoin y criptomonedas).",
        "🔹 **Blockchain 2.0** → Smart contracts y programación (Ethereum).",
        "🔹 **Blockchain 3.0** → Escalabilidad, rendimiento, interoperabilidad (Solana, Polkadot, Cosmos, Algorand).",
        "🔹 **Blockchain 4.0** → Web3, identidad, descentralización real, integración con IA y automatización."
      ]
    },
    {
      heading: "Ethereum y la Blockchain de segunda generación (Blockchain 2.0)",
      text: [
        "En 2014, se produjo un salto fundamental con la publicación del **whitepaper de Ethereum**, escrito por Vitalik Buterin.",
        "Ethereum se lanzó oficialmente en **2015**, introduciendo la gran innovación que transformaría la tecnología blockchain: los **smart contracts o contratos inteligentes**.",
        "Aunque la idea original de los contratos inteligentes fue propuesta por **Nick Szabo** años antes, Ethereum fue la primera plataforma en implementarlos de forma funcional y programable.",
        "Gracias al lenguaje de programación **Solidity**, Ethereum permitió crear aplicaciones descentralizadas (DApps), tokens, organizaciones autónomas (DAO) y protocolos financieros (DeFi).",
        "Esta nueva etapa permitió que blockchain dejara de ser solo 'dinero digital' para convertirse en una plataforma programable para construir aplicaciones de todo tipo."
      ]
    },
    {
      heading: "Hacia la escalabilidad y la adopción masiva: Blockchain 3.0",
      text: [
        "Con el crecimiento de usuarios y aplicaciones, surgió la necesidad de mejorar el **rendimiento, velocidad e interoperabilidad**.",
        "Así nació la **Blockchain 3.0**, enfocada en resolver problemas como el alto consumo energético, la congestión de la red y los costos elevados por transacción.",
        "Algunas cadenas destacadas de esta generación son:"
      ],
      list: [
        "🔹 **Solana** — Alta velocidad (50,000+ TPS) y Proof of History.",
        "🔹 **Polkadot** — Interoperabilidad entre blockchains.",
        "🔹 **Algorand** — Finalidad casi instantánea.",
        "🔹 **Cosmos** — Ecosistema de cadenas interconectadas."
      ],
      textAfter: [
        "El objetivo de esta etapa es hacer que blockchain sea lo suficientemente eficiente, rápida y escalable como para usarse en soluciones reales como bancos, gobiernos y empresas globales."
      ]
    },
    {
      heading: "El futuro: Blockchain 4.0 y el nacimiento de la Web3",
      text: [
        "La evolución actual de blockchain se centra en la construcción de **Web3**, una versión descentralizada de Internet donde los usuarios son dueños de sus datos, su identidad y sus activos.",
        "En la Web3, blockchain se combina con inteligencia artificial, identidad soberana, contratos inteligentes avanzados y automatización.",
        "El objetivo es crear una **economía digital descentralizada**, donde las personas puedan interactuar, crear y comerciar sin depender de plataformas centralizadas."
      ],
      list: [
        "🔹 Identidad digital soberana (Self-Sovereign Identity, SSI).",
        "🔹 Finanzas descentralizadas (DeFi).",
        "🔹 NFTs como representación de propiedad digital.",
        "🔹 Metaverso y activos virtuales tokenizados.",
        "🔹 DAOs: organizaciones descentralizadas gobernadas por código."
      ],
      textAfter: [
        "Blockchain ha pasado de ser una propuesta teórica a convertirse en una infraestructura global para la economía digital del futuro."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Desde el Bloque Génesis de Bitcoin en 2009 hasta las actuales tecnologías Web3, blockchain ha recorrido un camino extraordinario.",
        "Hoy, estamos en medio de una revolución tecnológica que va mucho más allá de las criptomonedas, transformando industrias, modelos económicos y la forma en que confiamos en la información digital.",
        "Y lo más importante: esta historia apenas está comenzando."
      ]
    }
  ]
};

export default CAP24;
